'use client'

import type { ReactNode } from 'react'
import { ViewTransition } from 'react'

const SUPPORT_OPEN_TYPE = 'support-open'
const EASE_OUT = 'cubic-bezier(0.23, 1, 0.32, 1)'
const ENTER_DURATION_MS = 320
const ENTER_DELAY_MS = 60
const REDUCED_MOTION_DURATION_MS = 200

const ENTER_KEYFRAMES: Keyframe[] = [
  { opacity: 0, transform: 'translateY(16px) scale(0.985)' },
  { opacity: 1, transform: 'translateY(0) scale(1)' },
]
const REDUCED_MOTION_KEYFRAMES: Keyframe[] = [{ opacity: 0 }, { opacity: 1 }]

interface SupportPageTransitionProps {
  children: ReactNode
}

/**
 * Entrada da página /suporte quando o clique vem do link "Suporte" do rodapé
 * (`transitionTypes={['support-open']}`). Sem esse tipo (URL direta, voltar,
 * outros links) não anima. A animação roda via WAAPI no pseudo `new` — não
 * depende de CSS com `::view-transition-new(.classe)`.
 */
export function SupportPageTransition({
  children,
}: SupportPageTransitionProps) {
  return (
    <ViewTransition
      default="none"
      enter={{ [SUPPORT_OPEN_TYPE]: 'support-enter', default: 'none' }}
      exit="none"
      onEnter={(instance, types) => {
        if (!types.includes(SUPPORT_OPEN_TYPE)) {
          return
        }

        const prefersReducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches

        instance.new.animate(
          prefersReducedMotion ? REDUCED_MOTION_KEYFRAMES : ENTER_KEYFRAMES,
          {
            duration: prefersReducedMotion
              ? REDUCED_MOTION_DURATION_MS
              : ENTER_DURATION_MS,
            delay: prefersReducedMotion ? 0 : ENTER_DELAY_MS,
            easing: EASE_OUT,
            fill: 'both',
          }
        )
      }}
    >
      {children}
    </ViewTransition>
  )
}
